module.exports = __webpack_public_path__ + "img/corner_person_screen.e8a5a66f.svg";